<template>
  <div class="notification-internship-widget">
    <div class="notification-container">
      <div class="header"></div>
      <div class="body" ref="widget">
        <ul v-closable="{ exclude: ['widget'], handler: 'hideStudentModal' }">
          <li class="assignments-item" v-if="item">
            <div class="assignments-item-header">
              <div class="assignments-item-brand">
                <img v-if="item.owner.customer_profile.logo" :src="$fullUrl(
                  'images/profiles/' + item.owner.customer_profile.logo
                )
                  " />
                <img v-else src="@/assets/icons/logo_avatar.svg" />
              </div>
              <div class="content">
                <div class="title-row">
                  <label class="assignment-title">{{ item.name }}</label>
                  <label class="assignment-company">{{
                    item.owner.customer_profile.name
                  }}</label>
                  <span class="address-loaction"><img width="10" src="@/assets/icons/green-map-marker.svg" />
                    {{ item.owner.customer_profile.address }}</span>

                  <button class="btn-description">Description</button>
                </div>
              </div>
            </div>
            <div class="assignments-item-body">
              <div class="assignments-info">
                <p class="assignment-desc">
                  {{ item.description }}
                </p>
              </div>
              <div class="divider-line-widget">
                <div class="line"></div>
              </div>
            </div>
            <div class="assignment-footer">
              <h3>Candidates</h3>
              <div class="student-widget">
                <div class="student-tabs">
                  <div class="student-tab" :class="{ active: selected_tab == 'applied' }"
                    @click="selectInterTab(item, 'applied')">
                    Applied Candidates
                  </div>
                  <div class="student-tab" :class="{ active: selected_tab == 'selected' }"
                    @click="selectInterTab(item, 'selected')">
                    Selected Candidate
                  </div>
                </div>
                <div class="student-tab-body" v-if="selected_tab == 'applied'">
                  <table>
                    <tr>
                      <th>Candidate</th>
                      <th>Company</th>
                    </tr>
                    <tr v-for="(student, index) in item.interested" :key="index" :class="{ active: student.is_selected }">
                      <td @click="viewStudent(student)">
                        <div class="student-profile-widget">
                          <img :src="$fullUrl(
                            'images/profiles/' + student.profile_picture
                          )
                            " v-if="student.profile_picture" />
                          <img v-else src="@/assets/icons/logo_avatar.svg" alt="" />
                          <label>{{ student.first_name }}
                            {{ student.last_name }}</label>
                        </div>
                      </td>
                      <td>
                        <div class="school-profile-widget" @click="viewStudent(student)"
                          v-for="(school, i) in student.school" :key="i">
                          <img :src="$fullUrl('images/profiles/' + school.logo)" v-if="school.logo" />
                          <img v-else src="@/assets/icons/logo_avatar.svg" alt="" />
                          <label>{{ school.name }}</label>
                        </div>
                        <!-- View Candidate -->
                        <div class="student-modal-widget" v-if="student.is_selected">
                          <div class="student-modal-widget-header">
                            <div class="student-profile-info">
                              <img src="@/assets/icons/logo_avatar.svg" alt="" />
                              <div class="information">
                                <label class="names">{{ student.first_name }}
                                  {{ student.last_name }}</label>
                                <span class="loaction">{{
                                  student.profile.address
                                }}</span>
                              </div>
                            </div>
                            <div class="student-profile-option">
                              <c-button :loading="student.loading" @click="selectStudent(item, student)"
                                class="btn-select">Select</c-button>
                            </div>
                          </div>
                          <div class="student-modal-widget-body">
                            <div class="description-widget">
                              <label>Description</label>
                              <p v-html="student.profile.description"></p>
                            </div>
                            <div class="skills-widget">
                              <div class="skills_content__wrapper">
                                <div class="skill_box">
                                  <div class="skill_box_header">
                                    <label>Tools</label>
                                  </div>
                                  <div class="skill_box_body" v-if="student.skills.tools.length > 0">
                                    <div class="row__item" v-for="(
                                          value, i
                                        ) in student.skills.tools.slice(0, 5)" :key="i">
                                      <span>{{ value.name | validate }}</span>
                                      <star-rating inactive-color="#C1C1C1" :read-only="true" active-color="#1BA5A4"
                                        :star-size="14" :show-rating="false" v-model="value.level"></star-rating>
                                    </div>
                                  </div>
                                  <div class="skill_box_body" v-else>
                                    <div class="empty-skills">
                                      <p>Have not added any tool yet.</p>
                                    </div>
                                  </div>
                                </div>
                                <div class="skill_box">
                                  <div class="skill_box_header">
                                    <label>Domains</label>
                                  </div>
                                  <div class="skill_box_body" v-if="student.skills.domains.length > 0">
                                    <div class="row__item" v-for="(
                                          value, i
                                        ) in student.skills.domains.slice(0, 5)" :key="i">
                                      <span>{{ value.name | validate }}</span>
                                      <star-rating inactive-color="#C1C1C1" :read-only="true" active-color="#1BA5A4"
                                        :star-size="14" :show-rating="false" v-model="value.level"></star-rating>
                                    </div>
                                  </div>
                                  <div class="skill_box_body" v-else>
                                    <div class="empty-skills">
                                      <p>Have not added any domain yet.</p>
                                    </div>
                                  </div>
                                </div>
                                <div class="skill_box">
                                  <div class="skill_box_header">
                                    <label>Languages</label>
                                  </div>
                                  <div class="skill_box_body" v-if="student.skills.languages.length > 0">
                                    <div class="row__item" v-for="(
                                          value, i
                                        ) in student.skills.languages.slice(0, 5)" :key="i">
                                      <span>{{
                                        value.lang.name | validate
                                      }}</span>
                                      <star-rating inactive-color="#C1C1C1" :read-only="true" active-color="#1BA5A4"
                                        :star-size="14" :show-rating="false" v-model="value.level"></star-rating>
                                    </div>
                                  </div>
                                  <div class="skill_box_body" v-else>
                                    <div class="empty-skills">
                                      <p>Have not added any language yet.</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="next_skills_content__wrapper">
                                <div class="skill_box">
                                  <div class="skill_box_header">
                                    <label>Competences</label>
                                  </div>
                                  <div class="skill_box_body" v-if="false &&
                                    student.skills.competences.length > 0
                                    ">
                                    <div class="row__item" v-for="(
                                          value, i
                                        ) in student.skills.competences.slice(
                                          0,
                                          5
                                        )" :key="i">
                                      <span>{{ value.name | validate }}</span>
                                      <star-rating inactive-color="#C1C1C1" :read-only="true" active-color="#1BA5A4"
                                        :star-size="14" :show-rating="false" v-model="value.level"></star-rating>
                                    </div>
                                  </div>
                                  <div class="skill_box_body" v-else>
                                    <div class="empty-skills">
                                      <p>Have not added any competence yet.</p>
                                    </div>
                                  </div>
                                </div>
                                <div class="skill_box">
                                  <div class="skill_box_header">
                                    <label>Roles</label>
                                  </div>
                                  <div class="skill_box_body" v-if="student.skills.roles.length > 0">
                                    <div class="row__item" v-for="(
                                          value, i
                                        ) in student.skills.roles.slice(0, 5)" :key="i">
                                      <span>{{ value.name | validate }}</span>
                                      <star-rating inactive-color="#C1C1C1" :read-only="true" active-color="#1BA5A4"
                                        :star-size="14" :show-rating="false" v-model="value.level"></star-rating>
                                    </div>
                                  </div>
                                  <div class="skill_box_body" v-else>
                                    <div class="empty-skills">
                                      <p>Have not added any role yet.</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="student-tab-body" v-if="selected_tab == 'selected'">
                  <table>
                    <tr>
                      <th width="400">Candidate</th>
                      <th width="400">Company</th>
                      <th width="20"></th>
                    </tr>
                    <tr v-for="(student, index) in item.selected" :key="index" :class="{ active: student.is_selected }">
                      <td @click="viewStudent(student)">
                        <div class="student-profile-widget">
                          <img :src="$fullUrl(
                            'images/profiles/' + student.profile_picture
                          )
                            " v-if="student.profile_picture" />
                          <img v-else src="@/assets/icons/logo_avatar.svg" alt="" />
                          <label>{{ student.first_name }}
                            {{ student.last_name }}</label>
                        </div>
                      </td>
                      <td>
                        <div class="school-profile-widget" @click="viewStudent(student)"
                          v-for="(school, i) in student.school" :key="i">
                          <img :src="$fullUrl('images/profiles/' + school.logo)" v-if="school.logo" />
                          <img v-else src="@/assets/icons/logo_avatar.svg" alt="" />
                          <label>{{ school.name }}</label>
                        </div>
                        <!-- View Candidate -->
                        <div class="student-modal-widget" v-if="student.is_selected">
                          <div class="student-modal-widget-header">
                            <div class="student-profile-info">
                              <img src="@/assets/icons/logo_avatar.svg" alt="" />
                              <div class="information">
                                <label class="names">{{ student.first_name }}
                                  {{ student.last_name }}</label>
                                <span class="loaction">{{
                                  student.profile.address
                                }}</span>
                              </div>
                            </div>
                            <div class="student-profile-option">
                              <c-button :loading="student.loading" @click="moveStudentToIntern(item, student)"
                                class="btn-select">
                                Select
                              </c-button>
                            </div>
                          </div>
                          <div class="student-modal-widget-body">
                            <div class="description-widget">
                              <label>Description</label>
                              <p v-html="student.profile.description"></p>
                            </div>
                            <div class="skills-widget">
                              <div class="skills_content__wrapper">
                                <div class="skill_box">
                                  <div class="skill_box_header">
                                    <label>Tools</label>
                                  </div>
                                  <div class="skill_box_body" v-if="student.skills.tools.length > 0">
                                    <div class="row__item" v-for="(
                                          value, i
                                        ) in student.skills.tools.slice(0, 5)" :key="i">
                                      <span>{{ value.name | validate }}</span>
                                      <star-rating inactive-color="#C1C1C1" :read-only="true" active-color="#1BA5A4"
                                        :star-size="14" :show-rating="false" v-model="value.level"></star-rating>
                                    </div>
                                  </div>
                                  <div class="skill_box_body" v-else>
                                    <div class="empty-skills">
                                      <p>Have not added any tool yet.</p>
                                    </div>
                                  </div>
                                </div>
                                <div class="skill_box">
                                  <div class="skill_box_header">
                                    <label>Domains</label>
                                  </div>
                                  <div class="skill_box_body" v-if="student.skills.domains.length > 0">
                                    <div class="row__item" v-for="(
                                          value, i
                                        ) in student.skills.domains.slice(0, 5)" :key="i">
                                      <span>{{ value.name | validate }}</span>
                                      <star-rating inactive-color="#C1C1C1" :read-only="true" active-color="#1BA5A4"
                                        :star-size="14" :show-rating="false" v-model="value.level"></star-rating>
                                    </div>
                                  </div>
                                  <div class="skill_box_body" v-else>
                                    <div class="empty-skills">
                                      <p>Have not added any domain yet.</p>
                                    </div>
                                  </div>
                                </div>
                                <div class="skill_box">
                                  <div class="skill_box_header">
                                    <label>Languages</label>
                                  </div>
                                  <div class="skill_box_body" v-if="student.skills.languages.length > 0">
                                    <div class="row__item" v-for="(
                                          value, i
                                        ) in student.skills.languages.slice(0, 5)" :key="i">
                                      <span>{{
                                        value.lang.name | validate
                                      }}</span>
                                      <star-rating inactive-color="#C1C1C1" :read-only="true" active-color="#1BA5A4"
                                        :star-size="14" :show-rating="false" v-model="value.level"></star-rating>
                                    </div>
                                  </div>
                                  <div class="skill_box_body" v-else>
                                    <div class="empty-skills">
                                      <p>Have not added any language yet.</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="next_skills_content__wrapper">
                                <div class="skill_box">
                                  <div class="skill_box_header">
                                    <label>Competences</label>
                                  </div>
                                  <div class="skill_box_body" v-if="false &&
                                    student.skills.competences.length > 0
                                    ">
                                    <div class="row__item" v-for="(
                                          value, i
                                        ) in student.skills.competences.slice(
                                          0,
                                          5
                                        )" :key="i">
                                      <span>{{ value.name | validate }}</span>
                                      <star-rating inactive-color="#C1C1C1" :read-only="true" active-color="#1BA5A4"
                                        :star-size="14" :show-rating="false" v-model="value.level"></star-rating>
                                    </div>
                                  </div>
                                  <div class="skill_box_body" v-else>
                                    <div class="empty-skills">
                                      <p>Have not added any competence yet.</p>
                                    </div>
                                  </div>
                                </div>
                                <div class="skill_box">
                                  <div class="skill_box_header">
                                    <label>Roles</label>
                                  </div>
                                  <div class="skill_box_body" v-if="student.skills.roles.length > 0">
                                    <div class="row__item" v-for="(
                                          value, i
                                        ) in student.skills.roles.slice(0, 5)" :key="i">
                                      <span>{{ value.name | validate }}</span>
                                      <star-rating inactive-color="#C1C1C1" :read-only="true" active-color="#1BA5A4"
                                        :star-size="14" :show-rating="false" v-model="value.level"></star-rating>
                                    </div>
                                  </div>
                                  <div class="skill_box_body" v-else>
                                    <div class="empty-skills">
                                      <p>Have not added any role yet.</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td></td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="footer">
        <c-button class="btn-cancel" :loading="reject_loading" @click="rejectNotification()">Dismiss</c-button>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from "../main";
export default {
  name: "notification-internshi-view",
  components: {},
  computed: {},
  props: {},
  data: () => {
    return {
      item: null,
      reject_loading: false,
      selected_tab: "applied",
    };
  },
  mounted() {
    let vm = this;
    vm.initData();
  },
  methods: {
    initData() {
      let vm = this;
      if (vm.$route.params.id) {
        let internship_id = vm.$route.params.id;
        vm.getInternship(internship_id);
      }
    },
    hideStudentModal() {
      let vm = this;
      if (vm.item) {
        vm.item.interested.forEach((student) => {
          eventBus.$set(student, "is_selected", false);
        });
        vm.item.selected.forEach((student) => {
          eventBus.$set(student, "is_selected", false);
        });
      }
    },
    sendMessage(item, type) {
      let vm = this;
      if (type == "school") {
        let obj = {
          id: item.pivot.user_id,
        };
        vm.$emit("message", item);
      } else {
        vm.$emit("message", item);
      }
    },
    gotoProfile(item, type) {
      let vm = this;
      if (type == "people") {
        if (item.account_type == 1) {
          vm.$router.push({
            path: "/user/profile/" + item.id,
          });
        } else if (item.account_type == 2) {
          let item_id = window.btoa(item.id);
          let name =
            item.first_name.toLowerCase().replace(/\s/g, "-") +
            "-" +
            item.last_name.toLowerCase().replace(/\s/g, "-") +
            "-" +
            item_id;
          vm.$router.push({
            name: "customer-public-profile",
            params: { name: name },
          });
        } else if (item.account_type == 3) {
          let item_id = window.btoa(item.id);
          let name =
            item.first_name.toLowerCase().replace(/\s/g, "-") +
            "-" +
            item.last_name.toLowerCase().replace(/\s/g, "-") +
            "-" +
            item_id;
          vm.$router.push({
            name: "consultant-public-profile",
            params: { name: name },
          });
        } else if (item.account_type == 4) {
          let item_id = window.btoa(item.id);
          let name =
            item.first_name.toLowerCase().replace(/\s/g, "-") +
            "-" +
            item.last_name.toLowerCase().replace(/\s/g, "-") +
            "-" +
            item_id;
          vm.$router.push({
            name: "consultant-public-profile",
            params: { name: name },
          });
        }
      } else if (type == "companies") {
        let item_id = window.btoa(item.id);
        let name = item.name.toLowerCase().replace(/\s/g, "-") + "-" + item_id;
        vm.$router.push({
          name: "supplier-public-profile",
          params: { name: name },
        });
      } else if (type == "assignments") {
        let item_id = window.btoa(item.id);
        let name = item.title.toLowerCase().replace(/\s/g, "-") + "-" + item_id;
        vm.$router.push({
          name: "assignment-public-profile",
          params: { name: name },
        });
      }
    },
    moveStudentToIntern(intern, student) {
      let vm = this;
      student.loading = true;
      vm.$store
        .dispatch("CUSTOMER_MAKE_STUDENT_INTERN", {
          intern_id: intern.id,
          student_id: student.id,
        })
        .then((response) => {
          eventBus.$emit("openDialogMessage", {
            title: "Candidate selected successfully",
            message:
              "You have added " +
              student.first_name +
              " " +
              student.last_name +
              " to your interns list",
            action_label: "Go to interns",
            action_path: "/profile/customer/interns",
            action_close_label: "Later",
          });
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Candidate is now your intern",
            type: "success",
            duration: 3000,
          });
          student.loading = false;
          vm.initData();
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
          student.loading = false;
          console.log(error);
        });
    },
    processSkills(obj) {
      return obj.map((item) => {
        let skills = {
          tools: [],
          domains: [],
          languages: [],
          competences: [],
          roles: [],
        };
        if (item.skills.length && item.skills.length > 0) {
          item.skills.forEach((skill) => {
            skill.tools.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.tools.push(obj);
            });
            skill.domains.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.domains.push(obj);
            });
            skill.competences.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.competences.push(obj);
            });
            skill.roles.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.roles.push(obj);
            });
            skill.languages.forEach((item) => {
              if (item.lang) {
                let obj = {
                  lang: { name: item.lang.name },
                  level: parseInt(item.level),
                };
                skills.languages.push(obj);
              }
            });
          });
        }
        eventBus.$set(item, "skills", skills);
        return item;
      });
    },
    selectStudent(intern, student) {
      let vm = this;
      student.loading = true;
      vm.$store
        .dispatch("CUSTOMER_SELECT_STUDENT", {
          intern_id: intern.id,
          student_id: student.id,
        })
        .then((response) => {
          eventBus.$emit("openDialogMessage", {
            title: "Candidate selected successfully",
            message:
              "Selected consultant from this step will appear to the Selected Candidate list waiting for final interns designation",
            action_label: "Go to selected list",
            action_func: () => {
              intern.selected_tab = "selected";
              vm.selected_tab = "selected";
              vm.getInternship(vm.$route.params.id);
            },
            action_close_label: "Later",
          });
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Candidate is now selected",
            type: "success",
            duration: 3000,
          });
          student.loading = false;
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
          student.loading = false;
          console.log(error);
        });
    },
    viewStudent(student) {
      let vm = this;
      if (!student.is_selected) {
        vm.hideStudentModal();
        student.is_selected = true;
      } else {
        student.is_selected = false;
      }
    },
    selectInterTab(item, type) {
      let vm = this;
      vm.selected_tab = type;
    },
    getInternship(internship_id) {
      let vm = this;
      vm.$store
        .dispatch("INTERNSHIP_GET_SINGLE", {
          id: internship_id,
        })
        .then((responce) => {
          vm.item = responce.data;
          let interested = vm.processSkills(vm.item.interested);
          eventBus.$set(vm.item, "interested", interested);
          vm.item.interested.forEach((student) => {
            eventBus.$set(student, "loading", false);
            eventBus.$set(student, "is_selected", false);
          });

          let selected = vm.processSkills(vm.item.selected);
          eventBus.$set(vm.item, "selected", selected);
          vm.item.selected.forEach((student) => {
            eventBus.$set(student, "loading", false);
            eventBus.$set(student, "is_selected", false);
          });
        })
        .catch((error) => { });
    },
    rejectNotification() {
      let vm = this;
      vm.reject_loading = true;
      vm.$store
        .dispatch("DECLINE_TOBE_MEMBER", {
          id: vm.$route.params.not_id,
        })
        .then((responce) => {
          vm.reject_loading = false;
          vm.$router.push({
            path: "/notifications",
          });
        })
        .catch((erro) => {
          vm.reject_loading = false;
        });
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.notification-internship-widget {
  background: #ededed;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 55px;
  overflow-y: scroll;
  height: 100vh;

  .notification-container {
    width: 700px;
    background: #fff;
    border-radius: 5px;
    padding: 20px;

    .header {
      padding: 10px;

      h1 {
        margin: 0px;
      }
    }

    .body {
      padding: 10px;

      ul {
        list-style: none;
        padding-left: 0px;

        .assignments-item {
          background: #ffffff;
          border-radius: 5px;
          margin-bottom: 10px;
          position: relative;
          padding: 0px 0px;
          border: 1px solid rgb(223, 223, 223);

          @media (min-width: 300px) and (max-width: 630px) {
            padding: 0px 0px;
          }

          .assignments-item-header {
            display: flex;
            padding: 10px 14px;

            .assignments-item-brand {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 60px;
              height: 60px;

              @media (min-width: 300px) and (max-width: 630px) {
                width: 60px;
                height: 60px;
              }

              img {
                width: 50px;
                height: 50px;
                border-radius: 50%;
                object-fit: cover;

                @media (min-width: 300px) and (max-width: 630px) {
                  width: 50px;
                  height: 50px;
                }
              }
            }

            .content {
              display: flex;
              width: 62%;
              padding-right: 5px;
              padding-left: 10px;
              justify-content: space-between;
              align-items: flex-start;
              padding-top: 6px;

              .title-row {
                width: 100%;

                .assignment-title {
                  font-size: 18px;

                  margin-bottom: 1px;
                  color: #000;
                  margin-bottom: 5px;
                  overflow: hidden;
                  text-decoration: none;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  width: 93%;
                  display: block;
                }

                .assignment-company {
                  font-size: 16px;

                  margin-bottom: 1px;
                  color: rgb(24, 24, 24);
                  margin-bottom: 5px;
                  overflow: hidden;
                  text-decoration: none;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  width: 93%;
                  display: block;
                }

                .address-loaction {
                  color: #1ba5a4;
                  margin-bottom: 5px;
                  font-size: 14px;
                  overflow: hidden;
                  text-decoration: none;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  width: 93%;
                  display: block;
                }

                span.date {
                  color: #808080;

                  font-size: 13px;
                  margin-bottom: 2px;
                  display: block;
                  margin-bottom: 5px;
                }

                .btn-description {
                  color: #0884af;
                  margin-left: 0px;
                  margin-top: 4px;
                  font-size: 14px;
                  display: flex;
                  align-items: center;

                  img {
                    width: 12px;
                    margin-left: 6px;
                  }
                }
              }

              .options {
                display: flex;
                align-items: flex-end;
                flex-direction: column;

                .date {
                  color: #808080;

                  font-size: 13px;
                  display: flex;
                  justify-content: flex-end;
                  width: 188px;
                  align-items: center;

                  .separator {
                    margin: 0px 5px;
                  }

                  @media (min-width: 300px) and (max-width: 630px) {
                    font-size: 11px;
                    width: 145px;
                  }
                }

                .status {
                  color: #000;

                  font-size: 13px;
                }

                .publish-btn,
                .un-publish-btn {
                  border: 1px solid #2f90b6;
                  border-radius: 5px;
                  padding: 6px 20px;
                  color: #2f90b6;
                  background: transparent;
                  cursor: pointer;
                }
              }
            }

            .assignment-options {
              display: flex;
              justify-content: flex-end;
              width: 30%;

              .btn-published {
                background: transparent;
                height: 40px;
                width: 125px;
                border-radius: 5px;
                color: #1ba5a4;
                font-style: italic;
                cursor: auto;
              }

              .btn-draft {
                background: transparent;
                height: 40px;
                width: 125px;
                border-radius: 5px;
                color: #2f90b6;
                font-style: italic;
                cursor: auto;
              }
            }

            .toogle-panel-btn {
              padding: 1px 7px;
              font-size: 16px;
              background: transparent;
              border: none;
              outline: none;
              cursor: pointer;
              color: #ccc;
              position: absolute;
              bottom: 10px;
              right: 5px;
              height: 15px;
            }
          }

          .assignments-item-body {
            padding-left: 85px;
            padding-right: 20px;
            padding-bottom: 15px;

            .assignments-info {
              .assignment-desc {
                color: #707070;
                margin-bottom: 11px;
              }
            }

            .divider-line-widget {
              display: flex;
              align-items: center;

              .line {
                width: 100%;
                border-bottom: 1px solid #ddd;
              }

              .btn-toogle {
                margin-left: 10px;
              }
            }
          }

          .assignment-footer {
            padding-left: 85px;
            padding-right: 20px;
            padding-bottom: 15px;

            h3 {
              font-size: 18px;
              margin-bottom: 10px;
            }

            .student-widget {
              .student-tabs {
                display: flex;
                margin-bottom: 7px;

                .student-tab {
                  height: 30px;
                  display: flex;
                  align-items: center;
                  padding: 0px 40px;
                  cursor: pointer;

                  &.active {
                    border-bottom: 3px solid #1ba5a4;
                    color: #1ba5a4;
                  }
                }
              }

              .student-tab-body {
                height: 300px;
                width: 100%;

                table {
                  border-collapse: separate !important;
                  border-spacing: 0;
                  width: 100%;

                  tr {
                    cursor: pointer;

                    &.active {
                      td {
                        border-top: 1px solid #1ba5a4;
                        border-bottom: 1px solid #1ba5a4;
                      }

                      td:first-child {
                        border-left: 1px solid #1ba5a4;
                        border-top-left-radius: 5px;
                        border-bottom-left-radius: 5px;
                      }

                      td:last-child {
                        border-right: 1px solid #1ba5a4;
                        border-top-right-radius: 5px;
                        border-bottom-right-radius: 5px;
                      }
                    }

                    th {
                      width: 200px;
                      padding: 10px;
                      color: #9f9f9f;
                    }

                    td {
                      padding: 5px 10px;
                      position: relative;

                      .student-profile-widget {
                        display: flex;
                        align-items: center;

                        img {
                          width: 30px;
                          height: 30px;
                          border-radius: 50%;
                          margin-right: 10px;
                        }

                        label {
                          margin: 0px;
                        }
                      }

                      .school-profile-widget {
                        display: flex;
                        align-items: center;

                        img {
                          width: 30px;
                          height: 30px;
                          border-radius: 50%;
                          margin-right: 10px;
                        }

                        label {
                          margin: 0px;
                        }
                      }

                      .student-modal-widget {
                        position: absolute;
                        top: 10px;
                        left: 0px;
                        height: 550px;
                        width: 350px;
                        background: #fff;
                        box-shadow: -4px -2px 4px rgba(0, 0, 0, 0.25);
                        border-radius: 10px;
                        border: 2px solid #1ba5a4;
                        z-index: 9999;
                        padding: 10px;
                        margin-bottom: 120px;

                        .student-modal-widget-header {
                          display: flex;
                          justify-content: space-between;
                          margin-bottom: 20px;
                          height: 40px;

                          .student-profile-info {
                            display: flex;

                            img {
                              height: 40px;
                              height: 40px;
                              border-radius: 50%;
                              margin-right: 10px;
                            }

                            .information {
                              display: flex;
                              flex-direction: column;
                            }
                          }

                          .student-profile-option {
                            display: flex;
                            align-items: center;

                            .btn-select {
                              background: #1ba5a4;
                              border-radius: 5px;
                              height: 40px;
                              padding: 0px 15px;
                              color: #fff;
                            }
                          }
                        }

                        .student-modal-widget-body {
                          overflow-y: auto;
                          height: calc(100% - 60px);

                          .description-widget {
                            label {
                              display: block;
                              margin-bottom: 10px;
                              font-size: 16px;
                            }

                            p {
                              font-size: 14px;
                              color: #707070;
                            }
                          }

                          .skills-widget {
                            .skills_content__wrapper {
                              display: grid;
                              grid-template-columns: 1fr 1fr;
                              grid-column-gap: 10px;
                              margin-bottom: 10px;

                              @media (min-width: 300px) and (max-width: 630px) {
                                grid-template-columns: 1fr;
                              }

                              .skill_box {
                                min-width: 0;
                                display: flex;
                                flex-direction: column;
                                width: 100%;
                                background: #fff;
                                border-radius: 5px;
                                margin-bottom: 15px;

                                .skill_box_header {
                                  border-bottom: 2px solid #f5f5f5;
                                  height: 50px;
                                  display: flex;
                                  align-items: center;
                                  justify-content: space-around;
                                  padding: 0px 15px;

                                  label {
                                    color: #0884af;
                                    width: 100%;
                                    font-size: 15px;
                                    font-weight: 800;
                                  }
                                }

                                .skill_box_body {
                                  padding: 0px 15px;

                                  .empty-skills {
                                    display: flex;
                                    flex-direction: column;
                                    align-items: center;
                                    height: 200px;
                                    justify-content: center;

                                    p {
                                      text-align: center;
                                      margin-bottom: 20px;
                                      color: #8d8d8d;
                                    }

                                    button {
                                      width: 133px;
                                      height: 36px;
                                      background: #1890a9 0% 0% no-repeat padding-box;
                                      border-radius: 5px;
                                      color: #fff;
                                    }
                                  }

                                  .row__item {
                                    margin-top: 10px;
                                    display: flex;
                                    margin-bottom: 10px;
                                    justify-content: space-between;
                                    width: 100%;

                                    span {
                                      color: #000000;
                                      font-weight: normal;
                                      margin-top: 2px;
                                      font-size: 14px;
                                      font-weight: 800;
                                    }
                                  }
                                }
                              }
                            }

                            .next_skills_content__wrapper {
                              display: grid;
                              grid-template-columns: 1fr 1fr;
                              grid-column-gap: 10px;

                              @media (min-width: 300px) and (max-width: 630px) {
                                grid-template-columns: 1fr;
                              }

                              .skill_box {
                                min-width: 0;
                                display: flex;
                                flex-direction: column;
                                width: 100%;
                                background: #fff;
                                border-radius: 5px;
                                margin-bottom: 15px;

                                .skill_box_header {
                                  border-bottom: 2px solid #f5f5f5;
                                  height: 50px;
                                  display: flex;
                                  align-items: center;
                                  justify-content: space-around;
                                  padding: 0px 15px;

                                  label {
                                    color: #0884af;
                                    width: 100%;
                                    font-size: 15px;
                                    font-weight: 800;
                                  }
                                }

                                .skill_box_body {
                                  padding: 0px 15px;

                                  .empty-skills {
                                    display: flex;
                                    flex-direction: column;
                                    align-items: center;
                                    height: 200px;
                                    justify-content: center;

                                    p {
                                      text-align: center;
                                      margin-bottom: 20px;
                                      color: #8d8d8d;
                                    }

                                    button {
                                      width: 133px;
                                      height: 36px;
                                      background: #1890a9 0% 0% no-repeat padding-box;
                                      border-radius: 5px;
                                      color: #fff;
                                    }
                                  }

                                  .row__item {
                                    margin-top: 10px;
                                    display: flex;
                                    margin-bottom: 10px;
                                    justify-content: space-between;
                                    width: 100%;

                                    span {
                                      color: #000000;
                                      font-weight: normal;
                                      margin-top: 2px;
                                      font-size: 14px;
                                      font-weight: 800;
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    .footer {
      padding: 10px;
      display: flex;
      align-items: center;

      .btn-save {
        width: 100px;
        height: 40px;
        background: #229ea5;
        border-radius: 6px;
        color: #fff;
        margin-right: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .btn-cancel {
        width: 100px;
        height: 40px;
        background: #fff;
        border-radius: 6px;
        color: #229ea5;
        margin-right: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>